import { AttributeValue } from 'app/components/attributes/attributes.model';
import { Entity } from 'app/pages/product/product.model';


export class Client extends Entity
{
    
    
    email: string;
    contact: number;
    description: string;
    otherContacts: string;
    address: string;
    phone: string;
    fiscalName: string;
    creationDate: Date;
    rut: string;

   

    /**
     * Constructor
     *
     * @param client
     */
    constructor(client?)
    {
        client = client || {};
        super(client);
        
        this.email = client.email ;
        this.contact = client.contact ;
        this.description = client.description ;
        this.otherContacts = client.otherContacts ;
        this.address = client.address ;
        this.phone = client.phone ;
        this.fiscalName = client.fiscalName ;
        this.rut = client.rut ;
        // this.createdBy= client.createdBy;
        this.creationDate = client.creationDate;

    }

}
